export default __webpack_public_path__ + "static/media/0Fish0.a89d18c9.png";